import { CommerceService } from "@/services/commerce"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getCustomer } from "../../shared/utils/getCustomer"

export const mutationRemoveLineItems = {
  async removeLineItems(parent, args, context, info) {
    let { cartKey, cartId, items = [], allItems } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.UPDATE,
    })

    const commerceApi = CommerceService.api()

    if (!cartId && !cartKey) return null
    const isKey = typeof cartKey === "string"

    const currentCart = isKey
      ? (await commerceApi.carts().withKey({ key: cartKey }).get().execute()).body
      : (await commerceApi.carts().withId({ ID: cartId }).get().execute()).body

    const customer = await getCustomer({ id: currentCart.customerId })

    if (!customer) {
      throw new Error("Customer not found")
    }

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    items = allItems
      ? currentCart.lineItems.map((item) => ({
          id: item.id,
          quantity: item.quantity,
        }))
      : items

    const action = "removeLineItem"
    const actions = items.map((item) => ({
      version: currentCart.version,
      action,
      lineItemId: item.id,
      ...(item.quantity && { quantity: item.quantity }),
    }))

    const payload = {
      version: currentCart.version,
      actions,
    }
    const cart = isKey
      ? (
          await commerceApi
            .carts()
            .withKey({ key: cartKey })
            .post({ body: JSON.stringify(payload) })
            .execute()
        ).body
      : (
          await commerceApi
            .carts()
            .withId({ ID: cartId })
            .post({ body: JSON.stringify(payload) })
            .execute()
        ).body

    return cart
  },
}
